/* Family Republic: narrow storefront search (Dagmara, 02.11.2026).
   Shopify's /search adds "similar" products that do not contain the searched word at all.
   Before a search is sent, each word becomes a group of field searches
   (product name, product type, brand, variant name, SKU, EAN) incl. simple Polish word forms,
   e.g. "plecak" -> (title:plecak OR product_type:plecak OR title:plecaki ...).
   Tags are left out on purpose: our category tags (torby, kubki) pulled in kosmetyczki / zakrętki.
   The first clause of every group is always title:<word as typed>; snippets/fr-search-terms.liquid
   reads it back so customers only ever see their own words.
   0 results -> sections/main-search.liquid falls back to the normal Shopify search. */
(function () {
  if (window.__frSearchNarrow) return;
  window.__frSearchNarrow = true;

  var STOP = ['i', 'w', 'z', 'ze', 'na', 'do', 'dla', 'od', 'o', 'a', 'u', 'oraz', 'lub', 'po', 'bez', 'the', 'and', 'of', 'for'];
  var VOWEL = /[aeiouyąęó]/;
  var LETTERS = /^[a-ząćęłńóśźż]+$/;

  // Simple Polish word forms (whole-word field search has no stemming and no prefix match).
  // Wrong guesses are harmless: a form that exists in no product name simply matches nothing.
  var SOFT = /(c|cz|sz|rz|ż|dz|ś|ć|ń|l|j)$/;
  function forms(w) {
    var out = [w];
    function add(x) { if (x && x.length >= 3 && out.indexOf(x) < 0) out.push(x); }
    if (w.length >= 3 && LETTERS.test(w)) {
      var last = w.slice(-1), stem = w.slice(0, -1), KG = /[kg]$/;
      var adj = w.length >= 5 && /(n|w|c|t|r|ł|d)[yae]$/.test(w);
      if (last === 'a') {                                   // torba, butelka, lampa
        add(stem + (KG.test(stem) ? 'i' : 'y'));
        if (/k$/.test(stem) && !VOWEL.test(stem.slice(-2, -1))) add(stem.slice(0, -1) + 'ek');
        else if (!KG.test(stem) && !adj) { add(stem + 'ka'); add(stem + 'ki'); }   // lampa -> lampka
      } else if (last === 'i' || last === 'y') {            // plecaki, klocki, torby
        add(stem); add(stem + 'a');
        if (/k$/.test(stem) && !VOWEL.test(stem.slice(-2, -1))) add(stem.slice(0, -1) + 'ek');
      } else if (last === 'e') {                            // ochraniacze, koce
        add(stem); add(stem + 'a');
      } else if (/ek$/.test(w)) {                           // wózek, kubek, smoczek
        var s = w.slice(0, -2) + 'k'; add(s + 'i'); add(s + 'a');
      } else if (!VOWEL.test(last)) {                       // plecak, rower, parasol, koc, kosz
        add(w + (KG.test(w) ? 'i' : 'y')); add(w + 'a');
        if (SOFT.test(w)) add(w + 'e');
        if (!KG.test(w)) {                                  // diminutives: rowerek, parasolka, kocyk, fotelik
          add(w + 'ek'); add(w + 'ki'); add(w + 'ka');
          var dim = /(c|cz|sz|rz|ż|dz)$/.test(w) ? 'yk' : 'ik';
          add(w + dim); add(w + dim + 'i');
        }
      }
      if (adj) {                                            // adjectives: magnetyczna -> magnetyczny / magnetyczne
        add(stem + 'y'); add(stem + 'a'); add(stem + 'e');
      }
    }
    return out;
  }

  function wordsOf(raw) {
    var q = String(raw || '').trim();
    if (!q || q.indexOf(':') > -1 || q.indexOf('(title') > -1) return [];
    return q.toLowerCase().replace(/[\u2018\u2019\u02bc`]/g, "'").replace(/[()"*:\\\[\]{}<>!?,;+=~^|&]/g, ' ').split(/\s+/)
      .map(function (w) { return w.replace(/^[-.']+|[-.']+$/g, ''); })
      .filter(function (w) { return w.length >= 2 && STOP.indexOf(w) < 0; });
  }

  function narrow(raw, maxWords) {
    var words = wordsOf(raw);
    if (!words.length || words.length > 6) return null;
    if (maxWords) words = words.slice(0, maxWords);
    return words.map(function (w) {
      var c = ['title:' + w];
      forms(w).forEach(function (f, i) {
        if (i > 0) c.push('title:' + f);
        c.push('product_type:' + f);
      });
      c.push('vendor:' + w, 'variants.title:' + w, 'variants.sku:' + w, 'variants.barcode:' + w);
      return '(' + c.join(' OR ') + ')';
    }).join(' ');
  }
  window.frNarrowSearch = narrow;

  function isSearchPath(path) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return path === root + 'search' || path === '/search';
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM' || (form.method || 'get').toLowerCase() !== 'get') return;
    var url;
    try { url = new URL(form.getAttribute('action') || '', location.href); } catch (err) { return; }
    if (url.origin !== location.origin || !isSearchPath(url.pathname)) return;
    var input = form.querySelector('input[name="q"]');
    var n = input && narrow(input.value);
    if (!n) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var params = new URLSearchParams(new FormData(form));
    params.set('q', n);
    params.set('fr_q', input.value.trim());
    if (!params.get('type')) params.set('type', 'product');
    location.href = url.pathname + '?' + params.toString();
  }, true);

  function fixLink(e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a) return;
    var url;
    try { url = new URL(a.href, location.href); } catch (err) { return; }
    if (url.origin !== location.origin || !isSearchPath(url.pathname)) return;
    var n = narrow(url.searchParams.get('q'));
    if (!n) return;
    url.searchParams.set('fr_q', url.searchParams.get('q'));
    url.searchParams.set('q', n);
    if (!url.searchParams.get('type')) url.searchParams.set('type', 'product');
    a.href = url.toString();
  }
  document.addEventListener('click', fixLink, true);
  document.addEventListener('auxclick', fixLink, true);

  // On the results page show exactly what the customer typed (fr_q) in the visible search fields.
  function showTyped() {
    if (!isSearchPath(location.pathname)) return;
    var typed = new URLSearchParams(location.search).get('fr_q');
    if (!typed) return;
    var q = new URLSearchParams(location.search).get('q') || '';
    if (q.indexOf('(title:') < 0) return;
    document.querySelectorAll('input[name="q"]').forEach(function (i) {
      if (i.type !== 'hidden' && i.value) i.value = typed;
    });
  }
  // 0 results (sections/main-search.liquid renders #fr-search-empty): first retry without the last word
  // ("plecak szkolny" -> "plecak"), and only when one word is left fall back to the normal Shopify search.
  function relax() {
    var el = document.getElementById('fr-search-empty');
    if (!el || /[?&]filter\./.test(location.search)) return;
    var u = new URL(location.href), q = u.searchParams.get('q') || '';
    var typed = u.searchParams.get('fr_q') || el.getAttribute('data-terms') || '';
    var groups = (q.match(/\(title:/g) || []).length;
    var next = groups > 1 ? narrow(typed, groups - 1) : null;
    if (!next && !typed) return;
    u.searchParams.set('q', next || typed);
    u.searchParams.delete('page');
    location.replace(u.toString());
  }
  function onReady() { relax(); showTyped(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onReady); else onReady();
})();
